import React, { useState } from 'react';

export const PerspectiveToggle = ({ globalRefs, globalState, ResetMap }) => {
    const mapRef = globalRefs.mapRef;
    const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    const is2DViewActive = globalState.is2DViewActive;
    const setIs2DViewActive = globalState.setIs2DViewActive;

    const togglePerspective = () => {
        const nextIs2D = !is2DViewActive;
        setIs2DViewActive(nextIs2D);
        if (nextIs2D) {
            polygonCustomLayerRef.current?.setCameraTo2DView();
            mapRef.current?.dragRotate.disable();
            mapRef.current?.touchZoomRotate.disableRotation();
        } else {
            polygonCustomLayerRef.current?.setCameraTo3DView(globalState.selectedYearEditing);
            mapRef.current?.dragRotate.enable();
            mapRef.current?.touchZoomRotate.enableRotation();
        }
        ResetMap(globalRefs, { ...globalState, is2DViewActive: nextIs2D });
    };

    return <ToggleRow label="2D view" checked={is2DViewActive} onClick={togglePerspective} />;
};

export const BasemapToggle = ({ globalRefs }) => {
    const [isSatellite, setIsSatellite] = useState(false);
    const mapRef = globalRefs.mapRef;

    const toggleBasemap = () => {
        const nextIsSatellite = !isSatellite;
        setIsSatellite(nextIsSatellite);

        mapRef.current.setPaintProperty(
            'mapbox-satellite',
            'raster-opacity',
            nextIsSatellite ? 1 : 0
        );
    };

    return (
        <ToggleRow
            label="Satellite"
            checked={isSatellite}
            onClick={toggleBasemap}
        />
    );
};

const ToggleRow = ({ label, checked, onClick }) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={onClick}
        style={{ width: '100%', minHeight: 38, padding: '0 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: '#fff', backgroundColor: '#29645D', border: 0, borderRadius: 0, cursor: 'pointer', transition: 'background-color 0.2s ease' }}
    >
        <span>{label}</span>
        <span className="map-view-toggle-track" style={{ position: 'relative', width: 28, height: 14, borderRadius: 12, backgroundColor: 'rgba(255,255,255,0.25)', flexShrink: 0 }}>
            <span className="map-view-toggle-thumb" style={{ position: 'absolute', top: 2, left: 2, width: 10, height: 10, borderRadius: '50%', backgroundColor: '#fff', transform: checked ? 'translateX(14px)' : 'translateX(0)', transition: 'transform 0.2s ease' }} />
        </span>
    </button>
);

